import MultiBarChart from "../../components/_common/BarChart/MultiBarChart";
import Spinner from "../../components/_common/Spinner";

export interface InputProps {
    data: any,
    isloading: Boolean; 
  }
  
// const data1 = [
//   {
//     name: 'کنترل', count: 4, failedCount: 2
//   },
//   {
//     name: 'کنترل تست', count: 3, failedCount: 1
//   },
//   {
//     name: 'T-Britin', count: 5, failedCount: 2
//   },
//   {
//     name: 'اقدام اصلاحی', count: 2
//   },
// ];
  const color = ["#12e4dd","#f49f17"]
  const legendLabel = [
    {
      name: 'count', value:"تعداد کل انجام شده"
    },
    {
      name: 'failedCount', value:"هشدار تعداد غیرمجاز"
    }
    
  ];

  const QC = ({data,isloading}:InputProps) =>{
    let chartData:any[]=[];
    let flag = false;

    const getChartData =()=>{
        data.map((item:any)=>{
          chartData.push({name:"کنترل", count:item.ControlCount,failedCount:item.ControlFailedCount});
          chartData.push( {name:"کنترل تست", count:item.TestControlCount,failedCount:item.TestControlFailedCount});
          chartData.push({name:"Tbritin", count:item.TbritinCount,failedCount:item.TbritinFailedCount});
          chartData.push({name:"اقدام اصلاحی", count:item.CorrectionActionCount});
        })
        chartData.map((item:any)=>{
          if(item.count !==0 ) {
            flag = true;
            return;
          }
        })
      }
    return(
        <div className="tab-content-padding">
        {  isloading === false  && (
            getChartData(),
            <>
            { 
            flag &&(
            <MultiBarChart data={chartData} colors={color}  legendLabel={legendLabel}/>
            )
      } 
      {
       flag === false &&
       (<p className="empty-data">داده ای برای نمایش موجود نیست.</p>)
      }
      </>
     )
     
 }
        {
          isloading === true  && (
          <Spinner />
        )
        }
        </div>
            )
        
        }
        
    export default QC;